// extracted by mini-css-extract-plugin
export var downArrow = "_i1-0";
export var infoTooltipIcon = "_i1-3";
export var label = "_i1-1";
export var optionCard = "_i1-4";
export var upArrow = "_i1-2";